import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import * as RadixDialog from '@radix-ui/react-dialog'
import * as ScrollArea from '@radix-ui/react-scroll-area'
import {AnimatePresence, motion} from 'motion/react'
import * as React from 'react'
import {cn} from '../cn'
import {useDialogState} from './Dialog'
import {DialogClose} from './DialogClose'
import {DialogOverlay} from './DialogOverlay'







export const DialogContent = React.forwardRef(
  ({className, children, noClose, onInteractOutside, ...props}, ref) => {
    const {isOpen} = useDialogState()
    return (
      _jsx(AnimatePresence, { children: 
        isOpen && (
          _jsxs(RadixDialog.Portal, { forceMount: true, children: [
            _jsx(DialogOverlay, { className: "z-10",} )
            , _jsx(RadixDialog.Content, {
              forceMount: true,
              asChild: true,
              'aria-describedby': undefined,
              onInteractOutside: (e) => {
                // MUI pickers render popovers in a portal outside the dialog — don't close
                if (_optionalChain([(e.target ), 'optionalAccess', _ => _.closest, 'call', _2 => _2('[data-popper-placement]')])) {
                  e.preventDefault()
                  return
                }
                _optionalChain([onInteractOutside, 'optionalCall', _3 => _3(e)])
              },
              ...props,
 children: 
              _jsxs(motion.div, {
                ref: ref,
                className: cn(
                  'fixed top-[50%] left-[50%] z-20 flex max-h-[85vh] w-[95vw] max-w-[95vw] translate-x-[-50%] translate-y-[-50%] flex-col overflow-hidden rounded-lg bg-surface-card shadow-dialog focus:outline-hidden md:w-2xl md:max-w-2xl dark:border dark:border-hairline-strong',
                  className
                ),
                initial: {opacity: 0, y: 8},
                animate: {opacity: 1, y: 0},
                exit: {opacity: 0, y: -8, transition: {duration: 0.15, ease: 'easeOut'}},
                transition: {duration: 0.25, ease: 'easeIn'},
 children: [
                _jsxs(ScrollArea.Root, { className: "flex-1 overflow-auto" , children: [
                  _jsx(ScrollArea.Viewport, { className: "p-6", children: children})
                  , _jsx(ScrollArea.Scrollbar, { orientation: "vertical",} )
                ]})
                , !noClose && _jsx(DialogClose, {} )
              ]})
            })
          ]})
        )
      })
    )
  }
)
